export default __webpack_public_path__ + "static/media/binance.1228492c.svg";